import { withSvgIconSimple } from './withSvgIconSimple';

export const ArrowDown = withSvgIconSimple(
  <path
    d="M16 11L12 15L8 11"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="square"
    strokeLinejoin="round"
  />,
  { viewBox: '0 0 24 24' },
);
